import React from "react";

import { FastshiftRunbookProduct } from "@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";
import { FormattedDate, FormattedMessage } from "react-intl";

import Lozenge from "@atlaskit/lozenge-next";
import { Box, Inline, Text, xcss } from "@atlaskit/primitives-next";

import { messages } from "./messages";

const metadataLabelStyles = xcss({
    flexShrink: 0,
    width: "76px"
});

const runbookProductMessageMapping = {
    JIRA: messages.runbooksPanelJiraProductName,
    CONFLUENCE: messages.runbooksPanelConfluenceProductName
};

const MetadataRow = ({
    label,
    children
}: {
    label: React.ReactNode;
    children: React.ReactNode;
}) => (
    <Inline alignBlock="baseline" space="space.100">
        <Box xcss={metadataLabelStyles}>
            <Text size="small" color="color.text.subtle">
                {label}
            </Text>
        </Box>
        <Box>{children}</Box>
    </Inline>
);

export const RunbookProductMetadata = ({
    product
}: {
    product: FastshiftRunbookProduct;
}) => (
    <MetadataRow
        label={<FormattedMessage {...messages.runbooksPanelProductLabel} />}
    >
        <Lozenge appearance="inprogress">
            <FormattedMessage {...runbookProductMessageMapping[product]} />
        </Lozenge>
    </MetadataRow>
);

export const RunbookResponsibleMetadata = ({ value }: { value: string }) => (
    <MetadataRow
        label={<FormattedMessage {...messages.runbooksPanelResponsibleLabel} />}
    >
        <Lozenge appearance="default">{value}</Lozenge>
    </MetadataRow>
);

export const RunbookDateMetadata = ({
    label,
    value
}: {
    label: React.ReactNode;
    value: string | number;
}) => (
    <MetadataRow label={label}>
        <Text size="small">
            <FormattedDate
                value={new Date(value)}
                day="2-digit"
                month="short"
                year="numeric"
            />
        </Text>
    </MetadataRow>
);
